<script lang="ts" setup>
export type LabelSize = 'normal' | 'big'

export interface LabelProps {
    label: string
    to?: VNuxtLinkTo
    classes?: string
    backgroundColor: string
    textColor: string
    size?: LabelSize
}
export interface VButtonEmits {
    // eslint-disable-next-line no-unused-vars
    (e: 'click', data: Event): void
}

const props = withDefaults(defineProps<LabelProps>(), {
    to: null,
    classes: '',
    size: 'normal',
})
</script>
<template>
  <VNuxtLink
    v-if="props.to"
    class="label label-link rounded d-flex align-items-center text-decoration-none fs-small transition px-2"
    :class="[props.classes, `label-${props.size}`]"
    :style="`--label-bg-color: ${props.backgroundColor}; --label-color: ${props.textColor};`"
    :to="props.to"
    :label="props.label"
  >
    {{ props.label }}
  </VNuxtLink>
  <span
    v-else
    class="label rounded border-0 d-inline-flex align-items-center text-decoration-none fs-small transition px-2"
    :class="[props.classes, `label-${props.size}`]"
    :style="`--label-bg-color: ${props.backgroundColor}; --label-color: ${props.textColor};`"
  >
    {{ props.label }}
  </span>
</template>
<style>
@import './Label.vars.scss';
</style>
<style scoped lang="scss">
@import './Label.scss';
</style>
